module.exports = __webpack_public_path__ + "static/img/tzzqq.c355a86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/tzzqq.png
// module id = 1TWc
// module chunks = 0